import { render, staticRenderFns } from "./SearchedContent.vue?vue&type=template&id=457e3f70&scoped=true&"
import script from "./SearchedContent.vue?vue&type=script&lang=js&"
export * from "./SearchedContent.vue?vue&type=script&lang=js&"
import style0 from "./SearchedContent.vue?vue&type=style&index=0&id=457e3f70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457e3f70",
  null
  
)

export default component.exports